import React, { useState } from "react";
import { StorageService } from "../../services/storage.js";
import {
  Search,
  Phone,
  Trash2,
  X,
  FileSpreadsheet
} from "lucide-react";
export const AdminSubmissions = ({
  submissions,
  currentUser,
  onSubmissionsUpdated
}) => {
  const [statusFilter, setStatusFilter] = useState("all");
  const [typeFilter, setTypeFilter] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [activeSub, setActiveSub] = useState(null);
  const [adminNotes, setAdminNotes] = useState("");
  const filtered = submissions.filter((sub) => {
    const matchesStatus = statusFilter === "all" || sub.status === statusFilter;
    const matchesType = typeFilter === "all" || sub.type === typeFilter;
    const q = searchQuery.toLowerCase().trim();
    const matchesSearch = !q || sub.full_name.toLowerCase().includes(q) || sub.phone.includes(q) || sub.message.toLowerCase().includes(q) || Boolean(sub.student_name && sub.student_name.toLowerCase().includes(q));
    return matchesStatus && matchesType && matchesSearch;
  });
  const handleOpenDetail = (sub) => {
    setActiveSub(sub);
    setAdminNotes(sub.admin_notes || "");
  };
  const handleStatusUpdate = (id, newStatus) => {
    StorageService.updateSubmissionStatus(id, newStatus, adminNotes);
    if (activeSub && activeSub.id === id) {
      setActiveSub({ ...activeSub, status: newStatus, admin_notes: adminNotes });
    }
    onSubmissionsUpdated();
  };
  const handleSaveNotes = () => {
    if (!activeSub) return;
    StorageService.updateSubmissionStatus(activeSub.id, activeSub.status, adminNotes);
    setActiveSub({ ...activeSub, admin_notes: adminNotes });
    onSubmissionsUpdated();
  };
  const handleDelete = (id) => {
    if (window.confirm("Delete this submission record?")) {
      StorageService.deleteSubmission(id);
      setActiveSub(null);
      onSubmissionsUpdated();
    }
  };
  const handleExportCsv = () => {
    const headers = ["ID", "Date", "Type", "Guardian Name", "Phone", "Email", "Student Name", "Age", "Class", "Subject", "Message", "Status", "Staff Notes"];
    const rows = filtered.map((s) => [
      s.id,
      s.created_at,
      s.type,
      `"${s.full_name.replace(/"/g, '""')}"`,
      `"${s.phone}"`,
      `"${s.email}"`,
      `"${s.student_name || ""}"`,
      `"${s.student_age || ""}"`,
      `"${s.class_applying || ""}"`,
      `"${s.subject.replace(/"/g, '""')}"`,
      `"${s.message.replace(/"/g, '""')}"`,
      s.status,
      `"${(s.admin_notes || "").replace(/"/g, '""')}"`
    ]);
    const csvContent = "data:text/csv;charset=utf-8," + [headers.join(","), ...rows.map((e) => e.join(","))].join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `baitul-muqaddas-submissions-${(/* @__PURE__ */ new Date()).toISOString().slice(0, 10)}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div>
          <h1 className="text-xl sm:text-2xl font-serif font-bold text-slate-900">
            Admission Inquiries & User Submissions
          </h1>
          <p className="text-xs text-slate-500">
            Moderate and follow up with parents, student admissions, and general contact inquiries
          </p>
        </div>

        <button
    onClick={handleExportCsv}
    className="px-3.5 py-2 text-xs font-semibold text-slate-700 bg-white hover:bg-stone-50 border border-stone-200 rounded-lg shadow-xs flex items-center gap-1.5 cursor-pointer self-start sm:self-auto"
  >
          <FileSpreadsheet className="w-3.5 h-3.5 text-emerald-700" />
          <span>Export to CSV</span>
        </button>
      </div>

      {
    /* Filter and Search Bar */
  }
      <div className="bg-white p-4 rounded-xl border border-stone-200 shadow-xs flex flex-col md:flex-row items-center justify-between gap-3">
        <div className="flex flex-wrap items-center gap-2 w-full md:w-auto">
          {
    /* Status filters */
  }
          <div className="flex items-center gap-1 bg-stone-100 p-1 rounded-lg">
            {["all", "new", "reviewed", "contacted", "archived"].map((status) => <button
    key={status}
    onClick={() => setStatusFilter(status)}
    className={`px-2.5 py-1 text-xs font-medium rounded-md capitalize cursor-pointer transition-colors ${statusFilter === status ? "bg-white text-emerald-950 font-bold shadow-xs" : "text-slate-600 hover:text-slate-900"}`}
  >
                {status}
              </button>)}
          </div>

          {
    /* Type filters */
  }
          <select
    value={typeFilter}
    onChange={(e) => setTypeFilter(e.target.value)}
    className="px-2.5 py-1.5 text-xs rounded-lg border border-stone-200 bg-stone-50 text-slate-700 cursor-pointer"
  >
            <option value="all">All Types</option>
            <option value="admission">Admissions</option>
            <option value="contact">General Contact</option>
            <option value="inquiry">Hifz / Hostel</option>
          </select>
        </div>

        {
    /* Search */
  }
        <div className="relative w-full md:w-64">
          <Search className="w-3.5 h-3.5 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <input
    type="text"
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    placeholder="Search parent name or phone..."
    className="w-full pl-8 pr-3 py-1.5 text-xs rounded-lg border border-stone-200 bg-stone-50 focus:bg-white focus:outline-none focus:ring-1 focus:ring-emerald-700"
  />
        </div>
      </div>

      {
    /* Submissions List Table */
  }
      <div className="bg-white rounded-2xl border border-stone-200 shadow-xs overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-xs">
            <thead className="bg-stone-50 border-b border-stone-200 text-slate-600">
              <tr>
                <th className="py-3 px-4 font-semibold">Date</th>
                <th className="py-3 px-4 font-semibold">Applicant / Guardian</th>
                <th className="py-3 px-4 font-semibold">Student & Class</th>
                <th className="py-3 px-4 font-semibold">Phone / WhatsApp</th>
                <th className="py-3 px-4 font-semibold">Message Preview</th>
                <th className="py-3 px-4 font-semibold">Status</th>
                <th className="py-3 px-4 font-semibold text-right">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-stone-100">
              {filtered.length === 0 ? <tr>
                  <td colSpan={7} className="py-8 text-center text-slate-400">
                    No submissions found matching criteria.
                  </td>
                </tr> : filtered.map((sub) => <tr
    key={sub.id}
    onClick={() => handleOpenDetail(sub)}
    className="hover:bg-stone-50/70 transition-colors cursor-pointer"
  >
                    <td className="py-3 px-4 text-slate-500 font-mono tabular-nums whitespace-nowrap">
                      {sub.created_at.substring(0, 16)}
                    </td>
                    <td className="py-3 px-4 font-semibold text-slate-900">
                      <div>{sub.full_name}</div>
                      <span className="text-[10px] text-slate-400 font-normal">
                        Type: {sub.type}
                      </span>
                    </td>
                    <td className="py-3 px-4 text-slate-700">
                      {sub.student_name ? <div>
                          <span className="font-medium text-slate-900">{sub.student_name}</span>
                          <span className="text-[11px] text-slate-500 block">
                            {sub.class_applying} ({sub.student_age || ""} yrs)
                          </span>
                        </div> : <span className="text-slate-400">—</span>}
                    </td>
                    <td className="py-3 px-4 font-mono text-emerald-800">
                      {sub.phone}
                    </td>
                    <td className="py-3 px-4 text-slate-600 max-w-xs truncate">
                      {sub.message}
                    </td>
                    <td className="py-3 px-4">
                      <span
    className={`inline-block px-2 py-0.5 text-[10px] font-bold rounded uppercase ${sub.status === "new" ? "bg-amber-100 text-amber-800" : sub.status === "reviewed" ? "bg-blue-100 text-blue-800" : sub.status === "contacted" ? "bg-emerald-100 text-emerald-800" : "bg-stone-100 text-slate-600"}`}
  >
                        {sub.status}
                      </span>
                    </td>
                    <td className="py-3 px-4 text-right">
                      <button
    onClick={(e) => {
      e.stopPropagation();
      handleOpenDetail(sub);
    }}
    className="px-2.5 py-1 text-xs font-semibold text-emerald-800 hover:bg-emerald-50 rounded cursor-pointer"
  >
                        View & Notes &rarr;
                      </button>
                    </td>
                  </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {
    /* Submission Detail Drawer / Modal */
  }
      {activeSub && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-xs animate-in fade-in duration-150">
          <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl overflow-y-auto border border-stone-200 max-h-[92vh]">
            <div className="p-6 space-y-6">
              {
    /* Header */
  }
              <div className="flex items-start justify-between border-b border-stone-200 pb-4">
                <div>
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-bold text-slate-400 font-mono">
                      #{activeSub.id}
                    </span>
                    <span className="px-2 py-0.5 rounded text-[10px] font-bold uppercase bg-stone-100 text-slate-700">
                      {activeSub.type}
                    </span>
                    <span
    className={`px-2 py-0.5 text-[10px] font-bold rounded uppercase ${activeSub.status === "new" ? "bg-amber-100 text-amber-800" : activeSub.status === "reviewed" ? "bg-blue-100 text-blue-800" : activeSub.status === "contacted" ? "bg-emerald-100 text-emerald-800" : "bg-stone-100 text-slate-600"}`}
  >
                      {activeSub.status}
                    </span>
                  </div>
                  <h2 className="text-xl font-bold text-slate-900 mt-1">
                    {activeSub.full_name}
                  </h2>
                  <span className="text-xs text-slate-500">
                    Received on {activeSub.created_at}
                  </span>
                </div>

                <button
    onClick={() => setActiveSub(null)}
    className="p-1 rounded-lg text-slate-400 hover:text-slate-700 cursor-pointer"
  >
                  <X className="w-5 h-5" />
                </button>
              </div>

              {
    /* Contact Info & Student details */
  }
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 bg-stone-50 p-4 rounded-xl text-xs">
                <div>
                  <span className="text-slate-500 block mb-0.5">Phone / WhatsApp:</span>
                  <a
    href={`tel:${activeSub.phone}`}
    className="font-bold text-emerald-800 hover:underline flex items-center gap-1.5"
  >
                    <Phone className="w-3.5 h-3.5" />
                    <span>{activeSub.phone}</span>
                  </a>
                </div>

                <div>
                  <span className="text-slate-500 block mb-0.5">Email Address:</span>
                  <span className="font-medium text-slate-800">{activeSub.email}</span>
                </div>

                {activeSub.student_name && <div>
                    <span className="text-slate-500 block mb-0.5">Student Name:</span>
                    <span className="font-bold text-slate-900">{activeSub.student_name}</span>
                  </div>}

                {activeSub.class_applying && <div>
                    <span className="text-slate-500 block mb-0.5">Applying For Class:</span>
                    <span className="font-bold text-emerald-900">{activeSub.class_applying}</span>
                  </div>}
              </div>

              {
    /* Message */
  }
              <div>
                <span className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-1">
                  Message Content:
                </span>
                <div className="p-4 bg-stone-50 rounded-xl text-xs text-slate-800 leading-relaxed whitespace-pre-line border border-stone-200">
                  {activeSub.message}
                </div>
              </div>

              {
    /* Staff Notes */
  }
              <div>
                <span className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-1">
                  Internal Staff Follow-up Notes:
                </span>
                <textarea
    rows={3}
    value={adminNotes}
    onChange={(e) => setAdminNotes(e.target.value)}
    placeholder="Record outcome of phone call, syllabus dispatch, or interview date..."
    className="w-full px-3 py-2 text-xs rounded-lg border border-stone-300 focus:outline-none focus:ring-1 focus:ring-emerald-700"
  />
                <button
    type="button"
    onClick={handleSaveNotes}
    className="mt-1.5 px-3 py-1.5 text-[11px] font-semibold text-emerald-800 bg-emerald-50 hover:bg-emerald-100 rounded-lg cursor-pointer"
  >
                  Save Internal Notes
                </button>
              </div>

              {
    /* Status Change Buttons & Delete */
  }
              <div className="flex flex-wrap items-center justify-between gap-3 pt-4 border-t border-stone-200">
                <div className="flex items-center gap-2">
                  <span className="text-xs text-slate-500">Update Status:</span>
                  <button
    onClick={() => handleStatusUpdate(activeSub.id, "reviewed")}
    className="px-2.5 py-1 text-xs font-medium rounded bg-blue-50 text-blue-700 hover:bg-blue-100 cursor-pointer"
  >
                    Reviewed
                  </button>
                  <button
    onClick={() => handleStatusUpdate(activeSub.id, "contacted")}
    className="px-2.5 py-1 text-xs font-medium rounded bg-emerald-50 text-emerald-700 hover:bg-emerald-100 cursor-pointer"
  >
                    Contacted
                  </button>
                  <button
    onClick={() => handleStatusUpdate(activeSub.id, "archived")}
    className="px-2.5 py-1 text-xs font-medium rounded bg-stone-100 text-slate-700 hover:bg-stone-200 cursor-pointer"
  >
                    Archived
                  </button>
                </div>

                {currentUser.role === "super_admin" && <button
    onClick={() => handleDelete(activeSub.id)}
    className="text-xs text-red-600 hover:text-red-800 font-semibold flex items-center gap-1 cursor-pointer"
  >
                    <Trash2 className="w-3.5 h-3.5" />
                    <span>Delete Record</span>
                  </button>}
              </div>
            </div>
          </div>
        </div>}
    </div>;
};
